// @flow

import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Modal } from 'react-bootstrap';
import PdfViewer from '../pdfViewer';

export default class PdfViewerModal extends Component {

  _isMounted = false;

  static defaultProps = {
    title: '',
    show: false,
    onHide: () => {},
    file: null,
    content: null,
    httpHeaders: {}
  };

  static propTypes = {
    show: PropTypes.bool.isRequired,
    onHide: PropTypes.func.isRequired,
    file: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    content: PropTypes.string,
    httpHeaders: PropTypes.object,
    // the modal title
    title: PropTypes.string
  };

  componentDidMount() {
    this._isMounted = true;
  }

  componentWillUnmount() {
    // mark unmounted to avoid state updates / leaks
    this._isMounted = false;
  }

  shouldComponentUpdate(nextProps) {
    return nextProps.show !== this.props.show;
  }

  // -- events - modal

  onHide = () => {
    this.props.onHide();
  };

  onClose = () => {
    this.props.onHide();
  };

  // -- renderers

  renderBody() {
    const { file, content, httpHeaders } = this.props;

    if (!file && !content) {
      return (
        <div className="row pdf_viewer_modal">
          <div className="pdf-placeholder">Aucun document sélectionné</div>
        </div>
      );
    }

    return (
      <div className="row pdf_viewer_modal">
        <PdfViewer
          file={file}
          content={content}
          httpHeaders={httpHeaders}
        />
      </div>
    );
  }

  render() {
    return (
      <Modal
        bsSize="large"
        show={this.props.show}
        onHide={this.onHide}
      >
        <Modal.Header>

          <button
            type="button"
            className="close close-white"
            onClick={this.onClose}
          >
            <span aria-hidden="true">×</span>
          </button>

          <Modal.Title>
            {this.props.title}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {this.renderBody()}
        </Modal.Body>
      </Modal>
    );
  }
}
